export const API_TO_APP_DETECTION_MAP = {
  'CD': 'cd',    
  'PD': 'pd',       
  'ID': 'id',       
  'VD': 'vd',       
  'VC': 'vc',      
  'LS': 'ls',       
  'US': 'us',       
  'CT': 'ct',
  'SH': 'sh',
  'II': 'ii',
  'OR': 'or',  
  'TA': 'ta'
        
};


export const APP_TO_API_DETECTION_MAP = {
  'cd': 'CD',       
  'pd': 'PD',       
  'id': 'ID',       
  'vd': 'VD',      
  'vc': 'VC',       
  'ls': 'LS',       
  'us': 'US',      
  'ct': 'CT', 
  'sh': 'SH',
  'ii': 'II',
  'or': 'OR',  
  'ta': 'TA'      
};


export const ALL_EVENT_TYPES = ["CD", "PD", "ID", "VD", "VC", "LS", "US", "CT", "SH", "II", "OR", "TA"];


export const VEHICLE_ALERT_BASE_URL = "http://192.168.29.244:3000";

// Vehicle alert endpoints
export const VEHICLE_ALERT_ENDPOINTS = {
  OFF_ROUTE: "/api/off-route/off-routes",
  TAMPER: "/api/tamper/tampers"
};

export const DETECTION_TYPE_CONFIG = {
  'cd': {
    apiTypes: ['CD'],
    title: 'Crowd Detection',
    color: '#1ABC9C'
  },
  'pd': {
    apiTypes: ['PD'],
    title: 'Person Detection',
    color: '#3498DB'
  },
  'id': {
    apiTypes: ['ID'],  
    title: 'Intrusion Detection',
    color: '#FFC107'   
  },
  'vd': {
    apiTypes: ['VD'],
    title: 'Vehicle Detection',
    color: '#E74C3C'
  },
  'vc': {
    apiTypes: ['VC'],
    title: 'Vehicle Counting',
  },
  'ct': {
    apiTypes: ['CT'],
    title: 'Camera Tampering',
    color: '#FF5722' 
  },
  'ls': {
    apiTypes: ['LS'],
    title: 'Line Crossing',
    color: '#F39C12'
  },
  'us': {
    apiTypes: ['US'],
    title: 'Unauthorized Surveillance',
    color: '#E67E22'
  },
  'sh': {
    apiTypes: ['SH'],
    title: 'Safety Hazard',
    color: '#9C27B0'  
  },
  'ii': {
    apiTypes: ['II'],
    title: 'Insufficient Illumination',
    color: '#795548'  
  },
    'or': {
    apiTypes: ['OR'],
    title: 'Off-Route Alert',
    color: '#4ECDC4',
    isVehicleAlert: true
  },
  'ta': {
    apiTypes: ['TA'],
    title: 'Tamper Alert',
    color: '#E67E22',
    isVehicleAlert: true
  }
};
  
export const AREA_ENDPOINTS = {
  'Argada': { endpoint: 'argada.cclai.in', groupId: 2 },
  'Barka Sayal': { endpoint: 'barkasayal.cclai.in', groupId: 1 },
  'North Karanpura': { endpoint: 'nk.cclai.in', groupId: 3 },
  'Bokaro & Kargali': { endpoint: 'bk.cclai.in', groupId: 4 },
  'Kathara': { endpoint: 'kathara.cclai.in', groupId: 5 },
  'Giridih': { endpoint: 'giridih.cclai.in', groupId: 6 },
  'Amrapali & Chandragupta': { endpoint: 'amrapali.cclai.in', groupId: 7 },
  'Magadh & Sanghmitra': { endpoint: 'magadh.cclai.in', groupId: 8 },
  'Rajhara': { endpoint: 'rajhara.cclai.in', groupId: 9 },
  'Kuju': { endpoint: 'kuju.cclai.in', groupId: 10 },
  'Hazaribagh': { endpoint: 'hazaribagh.cclai.in', groupId: 11 },
  'Rajrappa': { endpoint: 'rajrappa.cclai.in', groupId: 12 },
  'Dhori': { endpoint: 'dhori.cclai.in', groupId: 13 },
  'Piparwar': { endpoint: 'piparwar.cclai.in', groupId: 14 }
};


export const getAllEventTypes = () => {
  return ALL_EVENT_TYPES;
};

export const getEventTypesForDetection = (detectionType) => {
  const config = DETECTION_TYPE_CONFIG[detectionType];
  if (config && config.apiTypes) {
    return config.apiTypes;
  }
  console.warn(`No configuration found for detection type: ${detectionType}`);
  return [];
};

export const mapApiEventTypeToApp = (apiEventType) => {
  return API_TO_APP_DETECTION_MAP[apiEventType] || null;
};

export const getEventTypeColor = (detectionType, apiEventType = null) => {
  const config = DETECTION_TYPE_CONFIG[detectionType];
  return config ? config.color : '#95A5A6'; // Default gray color
};

export const getEventTypeTitle = (detectionType, apiEventType = null) => {
  const config = DETECTION_TYPE_CONFIG[detectionType];
  return config ? config.title : 'Unknown Event Type';
};

export const isVehicleAlertType = (detectionType) => {
  return ['or', 'ta'].includes(detectionType);
};

export {
  API_TO_APP_DETECTION_MAP as default
};